import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function AgriStatCard({ icon, label, value, tone, helper, onClick, compact, dense }) {
  const isDense = compact && dense;

  return (
    <Card
      sx={{
        height: "100%",
        position: "relative",
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top right, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0) 45%)",
          pointerEvents: "none",
        },
      }}
      onClick={onClick}
    >
      <MDBox
        p={isDense ? 0.8 : compact ? 1.05 : 2.5}
        sx={{
          background: tone,
          minHeight: isDense ? 72 : compact ? 82 : 156,
          color: "#fff",
        }}
      >
        <MDBox
          display="flex"
          alignItems={compact ? "center" : "flex-start"}
          justifyContent="space-between"
          mb={isDense ? 0.15 : compact ? 0.3 : 2.5}
          gap={isDense ? 0.45 : compact ? 0.75 : 0}
        >
          <MDTypography
            variant="button"
            fontWeight="bold"
            sx={{
              color: "rgba(255,255,255,0.78)",
              fontSize: isDense ? "0.62rem" : compact ? "0.72rem" : undefined,
              lineHeight: isDense ? 1.12 : compact ? 1.18 : undefined,
              flex: 1,
              pr: compact ? 0.5 : 0,
            }}
          >
            {label}
          </MDTypography>
          <MDBox
            width={isDense ? "1.3rem" : compact ? "1.55rem" : "3rem"}
            height={isDense ? "1.3rem" : compact ? "1.55rem" : "3rem"}
            borderRadius={compact ? "9px" : "18px"}
            display="grid"
            placeItems="center"
            flexShrink={0}
            sx={{
              backgroundColor: "rgba(255,255,255,0.16)",
              backdropFilter: "blur(10px)",
            }}
          >
            <Icon
              sx={{ color: "#fff", fontSize: isDense ? "0.72rem" : compact ? "0.85rem" : undefined }}
            >
              {icon}
            </Icon>
          </MDBox>
        </MDBox>
        <MDTypography
          variant={compact ? "h6" : "h3"}
          fontWeight="bold"
          sx={{
            color: "#fff",
            mt: isDense ? 0.1 : compact ? 0.25 : 0.75,
            lineHeight: compact ? 1.05 : undefined,
            fontSize: isDense ? "0.95rem" : compact ? "1.1rem" : undefined,
          }}
        >
          {value}
        </MDTypography>
        {helper ? (
          <MDTypography
            variant="caption"
            sx={{
              color: "rgba(255,255,255,0.74)",
              mt: isDense ? 0.1 : compact ? 0.2 : 1,
              lineHeight: isDense ? 1 : compact ? 1.05 : undefined,
              fontSize: isDense ? "0.5rem" : compact ? "0.58rem" : undefined,
              whiteSpace: compact ? "nowrap" : undefined,
              overflow: compact ? "hidden" : undefined,
              textOverflow: compact ? "ellipsis" : undefined,
            }}
          >
            {helper}
          </MDTypography>
        ) : null}
      </MDBox>
    </Card>
  );
}

AgriStatCard.defaultProps = {
  helper: "",
  onClick: undefined,
  compact: false,
  dense: false,
};

AgriStatCard.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tone: PropTypes.string.isRequired,
  helper: PropTypes.string,
  onClick: PropTypes.func,
  compact: PropTypes.bool,
  dense: PropTypes.bool,
};

export default AgriStatCard;
